import { DocumentLoadInstrumentation } from '@opentelemetry/instrumentation-document-load'
import { UserInteractionInstrumentation } from '@opentelemetry/instrumentation-user-interaction'
import { XMLHttpRequestInstrumentation } from '@opentelemetry/instrumentation-xml-http-request'

import { CustomFetchInstrumentation } from './fetch'

export const INSTRUMENTATIONS = [
  {
    Instrument: CustomFetchInstrumentation,
    confKey: 'fetch'
  },
  {
    Instrument: DocumentLoadInstrumentation,
    confKey: 'document'
  },
  {
    Instrument: XMLHttpRequestInstrumentation,
    confKey: 'xhr'
  },
  {
    Instrument: UserInteractionInstrumentation,
    confKey: 'interactions'
  }
] as const
